import React, { useEffect, useState } from 'react'
import { HeaderText, StyledModalWorkout, Divider, DisableEnableButton, StyledBodyWellness, WellnessCategrydCard, CategoryCard, CardContent } from '../UserDashboard/styles'
import { Modal } from 'react-bootstrap'
import { CloseIconBranding, dropWellnessIcon, ProgressTickIcon } from '../../utils/icons'
import { CheckboxGrid, PillarCard } from '../../containers/Login/style';
import { InitiativeImageContainer } from './styles';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { GetInitiativesWithCategory, GetWellnessInititiveCategory, SaveWellnessPriority } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import {ImageUrl} from '../../utils/constants';
import { CommonButtonBorder } from '../common/commonStyles';
import { CustomCheckBoxButton } from '../CreateEvent/style';
import { showSuccessToast } from '../UserDashboard/ToastHelper';


function WellnessPrioritiesPopup({closePopup, showPopup }) {

  const [currentStep, setCurrentStep] = useState(1);
  const [categgoryLoading, setCategoryLoading] = useState(false);
  const [InitiativesData, setInitiativesData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showWellnessPopup, setShowWellnessPopup] = useState(false);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [wellnessPriority, setWellnessPriority] = useState([]);
  const [selectedPriorities, setSelectedPriorities] = useState([]);


  window.console.log("categgoryLoading",categgoryLoading)
  

  const handleSelectPriority = (item) => {
    setSelectedPriorities((prev) => {
      const alreadySelected = prev.includes(item.id);
      // REMOVE
      if (alreadySelected) {
        return prev.filter((id) => id !== item.id);
      }
      // LIMIT 3
      if (prev.length >= 3) {
        toast.error("You can select maximum 3 priorities");
        return prev;
      }
  
      // ADD ONLY ID
      return [...prev, item.id];
    });
  };




  useEffect(()=>{
    FetchInitiativesWithCatgory();
    FetchWellnessPriority();
  },[])



  const isDisabled = selectedPriorities?.length === 0 || selectedPriorities?.length > 3; 

  
  const handleDropDown = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };


  const FetchWellnessPriority = async()=>{
    try {
      const res = await fetchApi(GetWellnessInititiveCategory, "GET");
      if(res.status === 'success'){
        setWellnessPriority(res.data)   
        
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }
  

  const SelectProduct = (initiativeId, categoryId) => {

    setSelectedInterests((prev) => {
  
      // already selected
      const alreadySelected = prev.find(
        (item) => item.id === initiativeId
      );
  
      // REMOVE
      if (alreadySelected) {
        return prev.filter(
          (item) => item.id !== initiativeId
        );
      }
  
      // count selected initiatives in SAME category
      const sameCategoryCount = prev.filter(
        (item) => Number(item.categoryId) === Number(categoryId)
      ).length;
  
      // BLOCK > 2 per category
      if (sameCategoryCount >= 2) {
        toast.error("You can select maximum 2 initiatives per category");
        return prev;
      }
  
      // BLOCK > 6 total
      if (prev.length >= 6) {
        toast.error("You can select maximum 6 initiatives");
        return prev;
      }
  
      // ADD
      return [
        ...prev,
        {
          id: initiativeId,
          categoryId: categoryId,
        },
      ];
    });
  };


  const closeWellnessPopup = ()=>{
    setShowWellnessPopup(false);
    setCurrentStep(1);
  }

  const FetchInitiativesWithCatgory = async () => {
    setCategoryLoading(true);
  
    try {
      const payload = {
        company_id: 1,
        category_id: selectedPriorities,
      };
  
      const res = await fetchApi(
        GetInitiativesWithCategory,
        "POST",
        payload
      );
  
      window.console.log("res", res);
  
      if (res.status === "success") {
        setInitiativesData(res.data);
        setCurrentStep(2)
        setShowWellnessPopup(true)
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setCategoryLoading(false);
    }
  };


  const handleBack = ()=>{
    if(currentStep === 2){
      setCurrentStep(1);
      setShowWellnessPopup(false);
    }} 


  const step1Modal = ( )=>{
    window.console.log("")
    return(
      <StyledModalWorkout isOverFlow={"hidden"} show={showPopup} newHeight={"468px"} newWidth={"1200px"}  isPadding={"20px 20px 16px 20px !important"}>
        <Modal.Header closeButton onClick={() => closePopup()}  style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading" >Your Wellness Priorities</div>
              <div className="closeIcon" onClick={()=>closePopup()}>{CloseIconBranding("#DA6C74",16,16)}</div>
            </div>
          </HeaderText>
        </Modal.Header>
        <Divider isWidth={"93%"} isOpacity={"40%"} isMargin={"0px 20px"}></Divider>
  
        <StyledBodyWellness  isMarginBottom={"8px"}  isOverFlow={"hidden"} isPadding={"16px !important"}>
          <div className="message">Step 1: Select your top 3 categories</div>
  
          <CheckboxGrid  isGap={"0px 12px"}>
            {wellnessPriority?.map((initiative, index)=>(
              <PillarCard    onClick={() => handleSelectPriority(initiative)} key={index} isMarginTop={"8px"} isCardPadding={"8px 24px 8px 8px"} isCardWidth={"378px"} isMinHeight={"64px"} >
                <InitiativeImageContainer style={{backgroundColor:initiative?.background_color}}>
                  <img src={`${ImageUrl}/${initiative.icon}`}  className="category-img" />
                </InitiativeImageContainer>
              
                <div className='text-container'>
                  <div className='productName'>{initiative?.category_name}</div>
                </div>
    
                <CustomCheckBoxButton
                  style={{ marginLeft: "auto" }}
                  isSelected={selectedPriorities.includes(initiative.id)}
                >
                  <div className="selection">
                    {selectedPriorities.includes(initiative.id)
                      ? ProgressTickIcon("#DA6C74")
                      : null}
                  </div>
                </CustomCheckBoxButton>
              </PillarCard>
            ))}
          </CheckboxGrid>
        </StyledBodyWellness>
        <Modal.Footer>
          <DisableEnableButton
            width={"300px"}
            isCursor={!isDisabled} 
            active={!isDisabled}
            disabledColor={isDisabled ? "#989898" : "#FEFEFE"}
            disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"}
            onClick={() => !isDisabled && FetchInitiativesWithCatgory()}
          >
            Next
          </DisableEnableButton>
        </Modal.Footer>
      </StyledModalWorkout>
    )
  }


  const SaveWellnessPriotityInitiatives = async () => {
    setCategoryLoading(true);

    const initiativeIds = selectedInterests.map(
      (item) => item.id
    );

    window.console.log("initiativeIds",initiativeIds)
  
    try {
      const payload = {
        company_id: 1,
        initiative_id: initiativeIds,
      };
  
      const res = await fetchApi(
        SaveWellnessPriority,
        "POST",
        payload
      );
  
      window.console.log("res", res);
  
      if (res.status === "success") {
        showSuccessToast(res.message);  
        // toast.success(res.message);
        setShowWellnessPopup(false)
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setCategoryLoading(false);
    }
  };




  const isStep2Disabled = () => {

    // must select exactly 6 initiatives total
    if (selectedInterests.length !== 6) {
      return true;
    }
  
    const categoryCounts = {};
  
    selectedInterests.forEach((item) => {
      categoryCounts[item.categoryId] =
        (categoryCounts[item.categoryId] || 0) + 1;
    });
  
    // always 3 categories should exist
    if (Object.keys(categoryCounts).length !== 3) {
      return true;
    }
  
    // every category must have exactly 2 selected
    const allCategoriesHaveTwo =
      Object.values(categoryCounts).every(
        (count) => count === 2
      );
  
    return !allCategoriesHaveTwo;
  };



  const step2Modal = ()=>{
    window.console.log("")
    return(
      <StyledModalWorkout show={showWellnessPopup} newWidth={"800px"}  isPadding={"20px !important"}>
      
        <Modal.Header closeButton onHide={closeWellnessPopup} style={{ background: "white" }}>
          <HeaderText>
            <div className="subContainer">
              <div className="popupHeading" >Your Wellness Priorities</div>
              <div className="closeIcon" onClick={()=>closeWellnessPopup()}>{CloseIconBranding("#DA6C74",16,16)}</div>
            </div>
          </HeaderText>
        </Modal.Header>
        <Divider isWidth={"93%"} isOpacity={"40%"} isMargin={"0px 20px"}></Divider>
  
        <StyledBodyWellness isPadding={"16px !important"}>
          <div className="message">Select 3–6 wellness initiatives. (Up to 2 initiatives per category.)</div>


          <WellnessCategrydCard>
            {InitiativesData?.categories?.map((category, index) => (
              <CategoryCard key={category.id}>
            
                <div
                  className="interest-container"
                  onClick={() => handleDropDown(index)}
                >
                  <div className="interestType">
                    {category?.category_name}
                  </div>
            
                  <div
                    style={{
                      transform:
                         activeIndex === index
                           ? "rotate(90deg)"
                           : "rotate(0deg)",
                      transition: "transform 0.3s ease"
                    }}
                    className="dropicon"
                  >
                    {dropWellnessIcon()}
                  </div>
                </div>
            
                {activeIndex === index && (
                  <div className="dropdown-wrapper">
             
                    {category?.initiatives?.map((item, i) => (
            
                      <CardContent
                        key={i}
                        onClick={() =>
                          SelectProduct(item.id, category.id)
                        }
                        userInterest={selectedInterests.some(
                          (s) => s.id === item.id
                        )}
                      >
             
                        <div className="listContent">
                          {item?.initiative_name}
                        </div>
            
                      </CardContent>
            
                    ))}
            
                  </div>
                )}
            
              </CategoryCard>
            ))}
       
          </WellnessCategrydCard>
        </StyledBodyWellness>


        <Modal.Footer>
          <div style={{ display: "flex", gap: "12px", marginTop: "20px", justifyContent: "center" }}>
            <CommonButtonBorder height="40px" width="300px" onClick={handleBack}>
              {"Back"}
            </CommonButtonBorder>
        
            <DisableEnableButton
              /* 👇 Add parenthetical execution () to run the validation */
              isCursor={!isStep2Disabled()} 
              active={!isStep2Disabled()}
              disabledColor={isStep2Disabled() ? "#989898" : "#FEFEFE"}
              disabledBg={isStep2Disabled() ? "#EFEFEF" : "#DA6C74"}
              disabled={isStep2Disabled()} 
              onClick={() => !isStep2Disabled() && SaveWellnessPriotityInitiatives()}
            >
              Done
            </DisableEnableButton>
          </div>
        </Modal.Footer>
    
      </StyledModalWorkout>
    )
  }



  if (!showPopup) return null;

  return (
    <>
      {currentStep === 1 ? step1Modal() : step2Modal()}    </>
  )
}



WellnessPrioritiesPopup.propTypes = {
  closePopup: PropTypes.func.isRequired,
  showPopup: PropTypes.bool.isRequired,
}

export default WellnessPrioritiesPopup;
